import { createElement } from 'react'

import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import PageHeaderDS from './page-header-ds'
import PageHeaderLegacy from './page-header-legacy'

// Router: keeps the `PageHeader` import path stable for every account consumer while switching each
// page to DS or legacy per the per-request DS decision. Untyped JS as before; the DS fork carries the
// types. `createElement` (not JSX) so this `.js` module parses under the test runner too.
const PageHeader = props => createElement(shouldUseDesignSystem() ? PageHeaderDS : PageHeaderLegacy, props)

export default PageHeader
